import axios from '@shared/helpers/axios';

const apiPath = 'api/v2/care-rooms';

const careRoomApi = {
    createRoom: (entity: Record<string, unknown> = {}) => {
        return axios.post(`${process.env.REACT_APP_API_URL}/${apiPath}/create-room`, {
            ...entity,
        });
    },
};

export default careRoomApi;
